import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { ButtonLink, Link } from '@change-corgi/design-system-legacy/components/actions';
import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useCTAButtonVariant } from 'src/app/pages/starterDashboardV2/shared/contexts';

import { useDashboardReskinExperiment } from '../../../../../../hooks/useDashboardReskinExperiment';

import { usePromoteYourPetition } from './hooks/usePromoteYourPetition';
import { PromoteYourPetition as PromoteYourPetitionReskin } from './index_new';

export const PromoteYourPetition: React.FC = () => {
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();
	const { data, actions } = usePromoteYourPetition();
	const { getCTAVariant } = useCTAButtonVariant();

	if (isEnabled) {
		return <PromoteYourPetitionReskin />;
	}

	return (
		<Card
			p="24px"
			backgroundColor="white"
			data-testid="promote-petition-container-control"
			data-qa="promote-petition-container"
			sx={{ border: 'unset', borderRadius: 'big' }}
		>
			<Heading as="h3" size="h4" id="promote-petition-title" data-qa="promote-petition-title">
				<Translate value="corgi.petition.starter_dashboard.grow_petition.promote.title" />
			</Heading>
			<Text as="p" mt="16px">
				<Translate
					value={`corgi.petition.starter_dashboard.grow_petition.promote.paragraph_1${
						data.shouldUseDonationLanguage ? '_donation' : ''
					}`}
				/>
			</Text>
			<Text as="p" mt="24px">
				<Translate value="corgi.petition.starter_dashboard.grow_petition.promote.paragraph_2" />
			</Text>
			<Flex sx={{ alignItems: 'center', flexWrap: 'wrap', gap: 16, mt: 24 }}>
				<Box sx={{ flexGrow: [1, 0] }}>
					<ButtonLink
						data-qa="promote-petition-button"
						data-testid="promote"
						to={data.promotionUrl}
						size="medium"
						variant={getCTAVariant('secondaryEmphasis')}
						onClick={actions.trackPromotePetitionClick}
						sx={{ width: '100%' }}
					>
						<Translate value="corgi.petition.starter_dashboard.grow_petition.promote.promote_button" />
					</ButtonLink>
				</Box>
				<Box sx={{ flexGrow: [1, 0] }}>
					<Link
						data-qa="promote-petition-learn-more-link"
						data-testid="learn_more"
						to={data.promotionHelpUrl}
						variant="primary"
						onClick={actions.trackLearnMoreClick}
						target="_blank"
						sx={{ fontSize: '14px' }}
					>
						<Translate value="corgi.petition.starter_dashboard.grow_petition.promote.learn_link" />
					</Link>
				</Box>
			</Flex>
		</Card>
	);
};
